import type { User } from '@/data/users/userSchemas'
import { GOVUK_COLOURS } from '@/components/govuk/colours'

export function getUserColour(
  author: string,
  users: User[],
  currentUser: string,
): string {
  if (!author) return GOVUK_COLOURS.midGrey
  return users.find((u) => u.name === author)?.colour ?? GOVUK_COLOURS.midGrey
}
